import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=645ce336&scoped=true&"
import script from "./ProjectForm.vue?vue&type=script&lang=js&"
export * from "./ProjectForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectForm.vue?vue&type=style&index=0&id=645ce336&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ce336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('645ce336')) {
      api.createRecord('645ce336', component.options)
    } else {
      api.reload('645ce336', component.options)
    }
    module.hot.accept("./ProjectForm.vue?vue&type=template&id=645ce336&scoped=true&", function () {
      api.rerender('645ce336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/preview/ProjectForm.vue"
export default component.exports